import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.expenses')
  .factory('$expenses', expensesArrayFactory);

function expensesArrayFactory($bringozFactory: $bringozFactory,
                              ExpensesApi: BringozApi,
                              Expenses_DS: DataStoreConfig) {

  function $expenses() {
    return $bringozFactory(null, ExpensesApi, Expenses_DS);
  }

  return $expenses;
}

